import axios from "@/plugins/axios";

let url = "/api/v1/pansim/insights";

export const insights = {
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
}